module.exports = __webpack_public_path__ + "static/media/profile_illustration.9fe8b968.png";